import { createApp } from 'vue';
import { createPinia } from 'pinia';
import dayjs from 'dayjs';
import App from './App.vue';
import { i18n } from './i18n';
import { dayjsLocale } from './i18n/dayjs';
import { router } from './router';
import { setSessionRefreshedHandler, setUnauthorizedHandler } from './api/client';
import { useSessionStore } from './stores/session.store';
import './styles/main.css';

// Sana yozuvlari (kalendar, ro'yxatlar) o'zbek lotin alifbosida
dayjs.locale(dayjsLocale);

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);
app.use(i18n);

/*
 * Access token muddati tugaganda interceptor o'zi `refresh` qiladi; bu yerga
 * faqat refresh ham yordam bermagan holat keladi (chiqib ketilgan yoki
 * sessiya bekor qilingan).
 */
setUnauthorizedHandler(() => {
  const session = useSessionStore(pinia);
  if (session.isAuthenticated) {
    session.clear();
    void router.push({
      name: 'no-session',
      query: { redirect: router.currentRoute.value.fullPath },
    });
  }
});

/*
 * Refresh muvaffaqiyatli bo'lsa foydalanuvchi ma'lumotini qayta o'qiymiz:
 * refresh oralig'ida rollari/ruxsatlari o'zgargan bo'lishi mumkin.
 */
setSessionRefreshedHandler(() => {
  void useSessionStore(pinia).reload();
});

app.mount('#app');
